import { render, staticRenderFns } from "./GbproHeroIcon.vue?vue&type=template&id=1886a192&scoped=true"
import script from "./GbproHeroIcon.vue?vue&type=script&lang=js"
export * from "./GbproHeroIcon.vue?vue&type=script&lang=js"
import style0 from "./GbproHeroIcon.vue?vue&type=style&index=0&id=1886a192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886a192",
  null
  
)

export default component.exports